<template>

    <v-progress-circular
        :size="120"
        :width="12"
        indeterminate
        color="primary"
        v-if="loading"
    >Loading</v-progress-circular>
 
</template>

<script>
export default {
  name: 'ProgressCircle',
    props: {
        loading: Boolean
    },
    mounted(){
        

    },
    methods: {

    },
    watch:{

    }
}
</script>

<style scoped>




</style>
